import "../../signup.css";
import React from "react";
import PropTypes from "prop-types";
import VmoCarouselDotGroup from "../Custom/VmoCarousel/VmoCarouselDotGroup";
import VmoCarouselSlide from "../Custom/VmoCarousel/VmoCarouselSlide";
import VmoCarouselSlider from "../Custom/VmoCarousel/VmoCarouselSlider";
import VmoCarouselProvider from "../Custom/VmoCarousel/VmoCarouselProvider";
import VmoHeader from "../Elements/VmoHeader/VmoHeader";
import VmoHeaderContent from "../Elements/VmoHeader/VmoHeaderContent";
import VmoHeaderSubheader from "../Elements/VmoHeader/VmoHeaderSubheader";
import VmoImage from "../Elements/VmoImage/VmoImage";
import { MdCheckCircle, MdFormatQuote } from "react-icons/md";
import VmoCardContent from "../Views/VmoCard/VmoCardContent";

export default function VmoSignupTestimonial({
  headline,
  subheadline,
  checklistItems,
  testimonials,
  happyClientsText,
  clientDetails,
}) {
  // Function to process text and wrap [bold]...[/bold] in <span> elements
  const processText = (text) => {
    return text.split(/\[bold\](.*?)\[\/bold\]/g).map((segment, index) => {
      if (index % 2 === 1) {
        // Content within [bold]...[/bold]
        return (
          <span className="bold-text" key={index}>
            {segment}
          </span>
        );
      } else {
        // Normal text
        return segment;
      }
    });
  };

  return (
    <React.Fragment>
      <div className="signupTestiBody">
        <p className="signup-head-text">{processText(headline)}</p>
        <p className="singup-sub-head">{subheadline}</p>
        <div className="singup-text-list">
          {checklistItems.map((item, index) => (
            <p key={index}>
              <MdCheckCircle />
              {processText(item)}
            </p>
          ))}
        </div>

        <VmoCarouselProvider
          className="testi-slider"
          naturalSlideWidth={100}
          isIntrinsicHeight
          totalSlides={testimonials.length}
        >
          <VmoCarouselSlider>
            {testimonials.map((testimonial, index) => (
              <VmoCarouselSlide index={index} key={index}>
                <div className="clientTesti">
                  <p>
                    <MdFormatQuote />
                    {processText(testimonial.quote)}
                  </p>

                  <VmoHeader as="h3">
                    <VmoImage avatar src={testimonial.customerImage} />
                    <VmoHeaderContent>
                      {testimonial.customerName}
                      <VmoHeaderSubheader>
                        {testimonial.customerTitle},
                        <a
                          href={testimonial.companyWebsite}
                          target="_blank"
                          rel="noreferrer"
                          className="ml-1"
                        >
                          {testimonial.companyName}
                        </a>
                      </VmoHeaderSubheader>
                    </VmoHeaderContent>
                  </VmoHeader>
                </div>
              </VmoCarouselSlide>
            ))}
          </VmoCarouselSlider>
          <VmoCarouselDotGroup />
        </VmoCarouselProvider>

        <div className="our-happy-clients">
          <p>{processText(happyClientsText)}</p>
          <div className="client-img">
            {clientDetails?.map((client, index) => (
              <img src={client?.image} alt={client?.name} />
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

VmoSignupTestimonial.propTypes = {
  headline: PropTypes.string.isRequired,
  subheadline: PropTypes.string.isRequired,
  checklistItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      quote: PropTypes.string,
      customerName: PropTypes.string,
      customerTitle: PropTypes.string,
      companyWebsite: PropTypes.string,
      companyName: PropTypes.string,
      customerImage: PropTypes.string,
    }).isRequired
  ).isRequired,
  happyClientsText: PropTypes.string.isRequired,
  clientDetails: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    })
  ).isRequired,
};

VmoSignupTestimonial.defaultProps = {
  headline:
    "Deliver world-class customer support [bold] faster than ever [/bold]",
  subheadline: "Get a 30 minutes Help Desk Demo with our Product Experts",
  checklistItems: [
    "Centralize your customer tickets and interactions in one place",
    "Reduce response times with [bold]automated support[/bold]",
    "Merge all your support channels in one platform",
  ],
  testimonials: [
    {
      quote:
        "Veemo Support has been great for us and helped us to reduce issues by [bold]35%[/bold] by automating our support and merging all our channels in one platform.",
      customerName: "Nilay Sheth",
      customerTitle: "Founder",
      companyWebsite: "https://www.nivida.in/",
      companyName: "nivida.in",
      customerImage: "https://i.pravatar.cc/300",
    },
    {
      quote:
        "Veemo Support has been great for us and helped us to reduce issues by [bold]35%[/bold] by automating our support and merging all our channels in one platform.",
      customerName: "Nilay Sheth two",
      customerTitle: "Founder",
      companyWebsite: "https://www.nivida.in/",
      companyName: "nivida.in",
      customerImage: "https://i.pravatar.cc/300",
    },
  ],
  happyClientsText: "OUR HAPPY CLIENTS",
  clientDetails: [
    {
      name: "Amit",
      image: "https://i.pravatar.cc/300",
    },
    {
      name: "Anand",
      image: "https://i.pravatar.cc/300",
    },
    {
      name: "Anand",
      image: "https://i.pravatar.cc/300",
    },
    {
      name: "Anand",
      image: "https://i.pravatar.cc/300",
    },
    {
      name: "Anand",
      image: "https://i.pravatar.cc/300",
    },
  ],
};
